
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class PaginationList extends Vue {
    @Prop(Number) readonly resultFrom!: number;
    @Prop(Number) readonly resultTo!: number;
    @Prop(Number) readonly total!: number;
    @Prop(String) readonly containerClass?: String;
    @Prop({type: Boolean, default: true, required: false}) readonly showmeta?: boolean;

    get resultFromValue(): Number {
      return this.resultFrom > this.total ? this.total : this.resultFrom;
    }

    get resultToValue(): Number {
      return this.resultTo > this.total ? this.total : this.resultTo;
    }
  }
